__turbopack_context__.v({
  "breadcrumb": "breadcrumb-module-scss-module__R5t49q__breadcrumb",
  "threeLineEllipse": "breadcrumb-module-scss-module__R5t49q__threeLineEllipse",
});
